import PatientConditionStateKey from "mco-keys/src/t4/PatientConditionStateKey"
import * as ActionTypes from "./types"

export interface UpdatePatientConditionModel {
	patientConditionId: number
	patientConditionStateKey: PatientConditionStateKey
	clientConditionId: string | null
	episodeNumber: string | null
	consentToShare: boolean
	ignoreValidationOnSave: boolean
}

export interface UpdatePatientConditionState {
	submitting: boolean
	hasFailedAttempt: boolean
}

const initial: UpdatePatientConditionState = {
	submitting: false,
	hasFailedAttempt: false
}

const reducer = (
	state: UpdatePatientConditionState = initial,
	action: any
): UpdatePatientConditionState => {
	switch (action.type) {
		case ActionTypes.UPDATE_PATIENT_CONDITION_REQUEST:
			return {
				...state,
				submitting: true
			}
		case ActionTypes.UPDATE_PATIENT_CONDITION_RECEIVE:
			return {
				...state,
				submitting: false
			}
		case ActionTypes.UPDATE_PATIENT_CONDITION_FAILURE:
			return {
				...state,
				submitting: false,
				hasFailedAttempt: true
			}
	}
	return state
}

export default reducer
